import useLanguage from "hooks/language";
import { CreditCardBrandIcon } from "./credit-card-brand-icon";
import { CreditCardInfo } from "./use-card-placeholder";

import styles from "./card-field.module.css";

type ReadonlyCardFieldProps = {
    creditCardInfo: CreditCardInfo;
    enableEditMode: () => void;
    containerClassName?: string;
};
export function ReadonlyCardField({
    creditCardInfo,
    enableEditMode,
    containerClassName = styles["card-container"],
}: ReadonlyCardFieldProps): JSX.Element {
    const { translations } = useLanguage();
    const localization = translations.upfrontPaymentSection;

    const formattedExpMonth = creditCardInfo.expMonth
        .toString()
        .padStart(2, "0");
    const formattedExpYear = creditCardInfo.expYear % 100;

    return (
        <div id="card-element" className={containerClassName}>
            <CreditCardBrandIcon
                brand={creditCardInfo.brand}
                styles={{ height: "2em" }}
            />
            <div className={styles["card-container__item-main"]}>
                <span>**** **** **** {creditCardInfo.last4}</span>
            </div>
            <div className={styles["card-container__item"]}>
                <span>
                    {formattedExpMonth}/{formattedExpYear}
                </span>
            </div>
            <div className={styles["card-container__item-end"]}>
                <button
                    className={styles["card-container__item-button"]}
                    onClick={enableEditMode}
                >
                    {localization.paymentForm.edit}
                </button>
            </div>
        </div>
    );
}
